<template>
  <v-stepper
      v-model="step"
  >
    <v-list-item
        dark
        two-line
        class="primary"
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-progress-check
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Progress</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click.prevent="minimize = !minimize">
          <v-icon v-if="!minimize">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-stepper-header class="pr-10" v-if="!minimize">
      <template v-for="(step, index) in progress">
        <v-stepper-step
            :key="'step_'+index"
            :step="index+1"
            :complete="step.complete"
            :rules="[() => !step.error]"
            :class="breakpoint"
        >
          {{ step.name }}
          <small v-if="'updated' in step && step.update !== null">{{ step.updated|formatlll }}</small>
        </v-stepper-step>
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
import moment from 'moment'

export default {
  components: {},
  name: 'ApplicationProgress',
  props: {
    progress: Array,
    step: Number
  },
  data() {
    return {
      minimize: false,
    }
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name
    }
  },
  filters: {
    formatlll(date) {
      if (date === null) {
        return ''
      }
      return moment(date).format('lll')
    }
  },
  methods: {},
  mounted() {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.v-stepper {
  &__header {
    height: auto !important;
  }

  &__step {
    /*
    &.xs {
      flex: 1 0 100%;
    }
    &.sm {
      flex: 1 0 50%;
    }
    */
    &.md {
      flex: 1 0 33%;
    }

    &.lg {
      flex: 1 0 21%;
    }

    &.xl {
      flex: 1 0 24%;
    }
  }
}
</style>